import { tailwindColors } from '@repo/tailwind-config/tailwind.vars'
import Badge from '@repo/ui/badge'
import { DisplayImage } from '@repo/ui/file-input'
import { WarningIcon } from '@repo/ui/icons'
import InnerBox from '@repo/ui/inner-box'
import Loader from '@repo/ui/loader'
import Modal from '@repo/ui/modal'
import Typography from '@repo/ui/typography'

import { useModalManager } from '../../lib/hooks/use-modal-manager'
import { useSecureFile } from '../../lib/hooks/use-secure-file'
import { SecureFileType } from '../../lib/types/models/file/file'

type Props = {
  picture: SecureFileType
}

const SecureImageViewCard = ({ picture }: Props) => {
  const { modalState, selectedData, toggleModal, closeModel } = useModalManager<
    'image-preview',
    SecureFileType
  >(['image-preview'])

  const { status, url, isLoading } = useSecureFile(picture.uploadId)

  const isError = status === 'INFECTED' || status === 'FAILED'

  return (
    <InnerBox className="rounded-lg bg-white-hover p-4 flex flex-col gap-3">
      <Badge variant="primary" size="small" text={picture.caption} />

      {isLoading ? (
        <div className="w-full h-48 rounded-lg flex items-center justify-center bg-grey-light-hover">
          <div className="flex flex-col items-center gap-2">
            <Loader size="sm" />
          </div>
        </div>
      ) : isError ? (
        <div className="w-full h-48 rounded-lg flex flex-col items-center justify-center gap-2 bg-red-50">
          <WarningIcon color={tailwindColors.secondaryRed.DEFAULT} />
          <Typography variant="label-semibold" color={tailwindColors.secondaryRed.DEFAULT}>
            {status === 'INFECTED'
              ? 'Fichier rejeté — virus détecté'
              : "Échec de l'analyse, réessayez"}
          </Typography>
        </div>
      ) : (
        <img
          src={url ?? undefined}
          alt="Photo de la famille"
          className="w-full h-48 object-cover rounded-lg cursor-pointer"
          onClick={() => toggleModal('image-preview', picture)}
        />
      )}

      {selectedData && url && (
        <Modal
          hideHeader
          hideActions
          size={'small'}
          isOpen={modalState['image-preview']}
          onCancel={() => closeModel('image-preview')}
        >
          <DisplayImage
            type={selectedData.type}
            src={url}
            className="w-full h-fit object-contain  "
          />
        </Modal>
      )}
    </InnerBox>
  )
}

export default SecureImageViewCard
